import { Pagination } from '@mui/material';
import {
    GridFooterContainer,
    gridPageSelector,
    gridPageSizeSelector,
    GridPagination,
    gridRowCountSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';

export function CustomTableFooter() {
    const apiRef = useGridApiContext();
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
    const page = useGridSelector(apiRef, gridPageSelector);
    const pages = Math.ceil(useGridSelector(apiRef, gridRowCountSelector) / pageSize);

    return (
        <GridFooterContainer
            sx={{
                px: 3,
                justifyContent: 'flex-end',
                '.MuiTablePagination-toolbar': { height: '50px', minHeight: '50px' },
                '.MuiTablePagination-selectLabel': { my: 1 },
                '.MuiTablePagination-actions': { display: 'none' },
            }}
        >
            <GridPagination />
            <Pagination
                count={pages == 0 ? 1 : pages}
                page={!pages || pages == 0 ? 1 : page + 1}
                onChange={(_, value) => apiRef.current.setPage(value - 1)}
                size="small"
            />
        </GridFooterContainer>
    );
}
